// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/ground-engine-fire.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/ground-engine-fire/ground-engine-fire.js';

mount([g0]);
